import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { getBlob } from '../../../../components/hooks/apiFetch';
import { AI_UTILITIES } from '../../../../constants/aiUtilities';

export const useSendToUtility = ({
    submitSummarizeResumeRequest,
    submitRetellingRequest,
    showInfo,
    showError
}) => {
    const history = useHistory();

    const sendToUtility = useCallback(async (record, fileUrl, submitRequest, routePath, utilityName) => {
        showInfo(`Загрузка файла для ${utilityName}...`);
        try {
            const blob = await getBlob(fileUrl);
            const file = new File([blob], record.fileName, { type: blob.type });
            const filesData = [{ file, path: record.fileName, outputFormat: 'txt' }];
            const { id, identifier } = await submitRequest(filesData, '');
            history.push(`${routePath}/${identifier}`, {
                id,
                fileNames: [record.fileName],
                comment: ''
            });
        } catch (error) {
            console.error(`Ошибка при отправке на ${utilityName}:`, error);
            showError(error.message || `Ошибка при отправке файла на ${utilityName}`);
        }
    }, [history, showInfo, showError]);

    const handleSendToSummarizeResume = useCallback((record, fileUrl) => {
        return sendToUtility(record, fileUrl, submitSummarizeResumeRequest, AI_UTILITIES.SUMMARIZE_RESUME.path, 'резюмирования');
    }, [sendToUtility, submitSummarizeResumeRequest]);

    const handleSendToRetelling = useCallback((record, fileUrl) => {
        return sendToUtility(record, fileUrl, submitRetellingRequest, AI_UTILITIES.RETELLING.path, 'пересказа');
    }, [sendToUtility, submitRetellingRequest]);

    return { handleSendToSummarizeResume, handleSendToRetelling }
        ;
};